import $ from 'jquery';
import plugin from '@core/plugins/lib';
export const ELEMENT_SELECTOR = '[data-banner-hero-block-slider]';
export const PLUGIN_NAME = 'bannerHeroBlockSlider';

$(document).ready(() => {
  $(ELEMENT_SELECTOR).each(function () {
	const element = this;
	System.import(/* webpackChunkName: "component--banner-hero-block-slider" */ './banner-hero-block-slider').then((module) => {
		plugin(PLUGIN_NAME, module.default);
		$(element)[PLUGIN_NAME]();
    });
  });
});



// WEBPACK FOOTER //
// ./project/client/src/site__def/components/epi-blocks/banner-hero/index.js